import { Grid, Link, Typography } from "@mui/material";
import { useAtomValue } from "jotai";
import React, { useEffect, useState } from "react";
import { appConfig, isAdminAtom } from "../../../../atoms";
import { AxiosRequest } from "../../../Url";
import { Rights } from "../../Tools/ProjectX";
import { selectNewLicenseToInstall } from "../../Tools/Tools";

const DialogAboutSite = () => {
  const {
    smeta: { stimateVersion: version },
  } = useAtomValue(appConfig);
  const userIsAdmin = useAtomValue(isAdminAtom);

  const [info, setInfo] = useState({
    CFGVer: "",
    Configuration: "",
    OCXVer: "",
    Release: "",
    Rights: "",
    SystemName: "",
    Using: "",
    Version: "",
  });

  useEffect(() => {
    const params = new Map();
    params.set("comand", "info").set("Info", "1").set("JSON", "1");
    AxiosRequest(true, params).then((resp: typeof info) => {
      setInfo(resp);
    });
  }, []);

  const resetLicense = (rcdata: string) => {
    const params = new Map();
    params.set("comand", "ResetLicense");
    AxiosRequest(true, params, { RCDATA: rcdata }).then((resp: typeof info) => {
      if (resp.SystemName && resp.Using) setInfo(resp);
    });
  };

  return (
    <Grid
      direction={"column"}
      spacing={1}
      sx={{
        alignItems: "center",
        justifyContent: "stretch",
        pl: 3,
        pr: 3,
      }}
    >
      <Grid>
        <Grid
          container
          direction={"column"}
          sx={{
            alignItems: "center",
            justifyContent: "stretch",
          }}
        >
          <Grid>
            <Typography variant="h5">
              Автоматизированная система
              {/* <br /> */}
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="h4">{info.SystemName}</Typography>
          </Grid>
          <Grid>
            <Typography variant="h6" gutterBottom>
              {info.Configuration}
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="subtitle2" gutterBottom>
              {info.Release}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid
          container
          direction={"column"}
          sx={{
            alignItems: "flex-start",
            justifyContent: "stretch",
            borderTop: "1px solid gray",
            borderBottom: "1px solid gray",
          }}
        >
          <Grid>
            <Typography variant="subtitle2" gutterBottom sx={{ whiteSpace: "pre-wrap" }}>
              {info.Using}
            </Typography>
          </Grid>
          {(userIsAdmin || userIsAdmin || Number(info.Rights) === Rights.All) && (
            <Grid
              sx={{
                width: "100%",
              }}
            >
              <Grid container direction={"row-reverse"}>
                <Grid>
                  <Link
                    underline="hover"
                    onClick={() => {
                      selectNewLicenseToInstall().then((fileData) => {
                        if (fileData && fileData.reqData.FileName && fileData.files) {
                          const fileName = fileData.reqData.FileName;
                          const rcdata = fileData.files[fileName].rcdata;
                          resetLicense(rcdata);
                        }
                      });
                    }}
                    sx={{ cursor: "pointer" }}
                  >
                    Обновить лицензию
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid>
        <Grid
          container
          direction={"column"}
          sx={{
            alignItems: "flex-start",
            justifyContent: "stretch",
          }}
        >
          <Grid>
            <Typography variant="subtitle2" gutterBottom sx={{ whiteSpace: "pre-wrap" }}>
              {`Версия сайта: ${version}`}
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="subtitle2" gutterBottom sx={{ whiteSpace: "pre-wrap" }}>
              {`Версия сервера: ${info.Version}`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DialogAboutSite;
